import { render } from "./PhotoAlbum.vue?vue&type=template&id=77137e9c&ts=true"
import script from "./PhotoAlbum.vue?vue&type=script&lang=ts"
export * from "./PhotoAlbum.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./PhotoAlbum.vue?vue&type=style&index=0&id=77137e9c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__